import { IconSVG } from '../types';

export const Eye = ({ size, style, ...props }: IconSVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    style={style}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#666"
      d="M12 16.5c1.25 0 2.313-.438 3.188-1.313.875-.874 1.312-1.937 1.312-3.187 0-1.25-.437-2.313-1.312-3.188C14.313 7.939 13.25 7.5 12 7.5c-1.25 0-2.312.438-3.187 1.313C7.938 9.687 7.5 10.75 7.5 12c0 1.25.438 2.313 1.313 3.188.875.874 1.937 1.312 3.187 1.312Zm0-1.8c-.75 0-1.387-.262-1.912-.787A2.604 2.604 0 0 1 9.3 12c0-.75.263-1.387.788-1.912A2.604 2.604 0 0 1 12 9.3c.75 0 1.388.262 1.913.787.525.526.787 1.163.787 1.913s-.262 1.387-.787 1.912A2.604 2.604 0 0 1 12 14.7Zm0 4.8c-2.233 0-4.27-.6-6.112-1.8-1.842-1.2-3.296-2.783-4.363-4.75a1.907 1.907 0 0 1-.187-1.438c.042-.158.104-.312.187-.462C2.592 9.083 4.046 7.5 5.888 6.3 7.73 5.1 9.768 4.5 12 4.5c2.234 0 4.271.6 6.113 1.8 1.842 1.2 3.296 2.783 4.362 4.75a1.906 1.906 0 0 1 .188 1.438 2 2 0 0 1-.188.462c-1.066 1.967-2.52 3.55-4.362 4.75-1.842 1.2-3.88 1.8-6.113 1.8Z"
    />
  </svg>
);
